var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlainMultiple = function SvgPlainMultiple(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0232 6.78998H3.37158C2.89325 6.78998 2.49658 7.18664 2.49658 7.66498V24.0216C2.49658 24.5 2.89325 24.8966 3.37158 24.8966H21.0116C21.4899 24.8966 21.8866 24.5 21.8866 24.0216V7.66498C21.8866 7.18664 21.4899 6.78998 21.0116 6.78998H21.0232ZM20.1482 23.1466H4.24658V8.53998H20.1366V23.1466H20.1482Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6282 3.10333H6.97656C6.49823 3.10333 6.10156 3.5 6.10156 3.97833C6.10156 4.45667 6.49823 4.85333 6.97656 4.85333H23.7416V17.3717C23.7416 17.85 24.1382 18.2467 24.6166 18.2467C25.0949 18.2467 25.4916 17.85 25.4916 17.3717V3.97833C25.4916 3.5 25.0949 3.10333 24.6166 3.10333H24.6282Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlainMultiple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "plain-multiple.b82470194f233c48fd2b620376387758.svg";